import React from "react";
import { useTranslation } from "react-i18next";
import TieDyeGallery from "./TieDyeGallery";

const Plan = () => {
  const { t } = useTranslation();

  return (
    <section id="plan">
      <h2>{t("plan.title")}</h2>

      {/* Friday Hike */}
      <h3>{t("plan.friday.hike.title")}</h3>
      <p>{t("plan.friday.hike.text")}</p>
      <ul style={{ textAlign: "start" }}>
        {t("plan.friday.hike.details", { returnObjects: true }).map(
          (item: string, idx: number) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>
      <p>
        <strong>{t("plan.friday.hike.note")}</strong>
      </p>

      {/* Friday Afternoon */}
      <h3>{t("plan.friday.afternoon.title")}</h3>
      <p>{t("plan.friday.afternoon.text")}</p>
      <ul style={{ textAlign: "start" }}>
        {t("plan.friday.afternoon.details", { returnObjects: true }).map(
          (item: string, idx: number) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>
      <TieDyeGallery />

      {/* Saturday */}
      <h2>{t("saturday.title")}</h2>
      <p>{t("saturday.intro1")}</p>
      <p>{t("saturday.intro2")}</p>
      <ul>
        <li>
          <strong>💄 {t("saturday.beautyStation.title")}</strong> –{" "}
          {t("saturday.beautyStation.desc")}
        </li>
        <li>
          <strong>🎲 {t("saturday.gameStation.title")}</strong> –{" "}
          {t("saturday.gameStation.desc")}
        </li>
        <li>
          <strong>📸 {t("saturday.photoCorner.title")}</strong> –{" "}
          {t("saturday.photoCorner.desc")}
        </li>
        <li>
          <strong>📺 {t("saturday.videoDisco.title")}</strong> –{" "}
          {t("saturday.videoDisco.desc")}
        </li>
        <li>
          <strong>🍽️ {t("saturday.buffet.title")}</strong> –{" "}
          {t("saturday.buffet.desc")}
        </li>
        <li>
          <strong>🧁 {t("saturday.macarons.title")}</strong> –{" "}
          {t("saturday.macarons.desc")}
        </li>
        <li>
          <strong>❓ {t("saturday.quiz.title")}</strong> –{" "}
          {t("saturday.quiz.desc")}
        </li>
      </ul>
      <p>{t("saturday.closing")}</p>
    </section>
  );
};

export default Plan;
